"use client";
// Imports
import { Menu, X } from "lucide-react";
import useStore from "@/lib/state";
import { MapPanel, MapPopout } from "@/components";

export function MobileMapDrawer({
  mapRef,
  selectedMarker,
  isModalOpen,
  daysOfShow,
  showDates,
  categories,
  zoomAwaySelectedLoc,
  setActiveCategory,
  setHoveredLocation,
  hoveredLocation,
  activeCategory,
  zoomToSelectedLoc,
  filteredLocations,
  searchWord,
  setSearchWord,
  showSearch,
  setShowSearch,
  setActivateBounce,
}) {
  const { isMobileMapDrawerOpen, toggleMobileMapDrawer } = useStore();

  function toggleCategory(category) {
    setActiveCategory(activeCategory === category.slug ? "all" : category.slug);
  }

  const topCategories = [
    "live-entertainment",
    "first-aid",
    "toilet",
    "shopping",
    "atm",
    "dining-catering-precinct",
  ];

  categories.sort((a, b) => a.slug.localeCompare(b.slug));

  categories.sort((a, b) => {
    if (topCategories.includes(a.slug) && topCategories.includes(b.slug)) {
      return topCategories.indexOf(a.slug) - topCategories.indexOf(b.slug);
    } else if (topCategories.includes(a.slug)) {
      return -1;
    } else if (topCategories.includes(b.slug)) {
      return 1;
    } else {
      return 0;
    }
  });

  return (
    <>
      {/* <button
        onClick={toggleMobileMapDrawer}
        className="absolute flex items-center justify-center bg-brand-wool rounded-full shadow-lg lg:hidden size-12 bottom-4 left-4"
      >
        <Menu />
      </button> */}
      <div
        className={`absolute bg-brand-wool ${
          isMobileMapDrawerOpen ? "translate-y-0" : "translate-y-full"
        } p-5 lg:hidden lg:p-10 bottom-0 ${
          selectedMarker ? "h-full" : "h-full min-h-[70%]"
        } shadow rounded-t-md max-h-[70%] w-full transition-all duration-500`}
      >
        <div className="absolute top-0 left-0 right-0 flex items-center justify-center -mt-8 lg:hidden">
          <button
            className="h-8 px-12 rounded-t-full bg-brand-red-gum text-white border-brand-red-gum"
            onClick={toggleMobileMapDrawer}
          >
            {!isMobileMapDrawerOpen ? <Menu /> : <X />}
          </button>
        </div>
        <MapPanel
          showSearch={showSearch}
          setShowSearch={setShowSearch}
          searchWord={searchWord}
          setSearchWord={setSearchWord}
          activeCategory={activeCategory}
          setActiveCategory={setActiveCategory}
          categories={categories}
          filteredLocations={filteredLocations}
          setHoveredLocation={setHoveredLocation}
          hoveredLocation={hoveredLocation}
          setActivateBounce={setActivateBounce}
          zoomToSelectedLoc={zoomToSelectedLoc}
          toggleCategory={toggleCategory}
        />
        <MapPopout
          mapRef={mapRef}
          zoomAwaySelectedLoc={zoomAwaySelectedLoc}
          selectedMarker={selectedMarker}
          daysOfShow={daysOfShow}
          showDates={showDates}
          isModalOpen={isModalOpen}
        />
      </div>
    </>
  );
}
